import React from 'react';
import { Truck, Ship, Globe } from 'lucide-react';

const LogisticsSection = () => {
  const features = [
    {
      icon: Globe,
      title: 'International Routes',
      description: 'Established logistics routes from Kazakhstan to international markets'
    },
    {
      icon: Truck,
      title: 'Flexible Delivery',
      description: 'Delivery arrangements tailored to customer requirements'
    },
    {
      icon: Ship,
      title: 'Export Management',
      description: 'Complete export logistics organization and coordination'
    }
  ];

  return (
    <section id="logistics" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <p className="text-emerald-700 text-sm font-medium tracking-widest uppercase mb-6">Supply Chain</p>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-12 tracking-tight">
            Export Logistics
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              Our company organizes export deliveries from Kazakhstan to international markets using established logistics routes. Flexible arrangements are available based on customer requirements.
            </p>
          </div>
        </div>

        {/* Logistics Image */}
        <div className="mb-20">
          <img
            src="https://images.unsplash.com/photo-1745771239062-8295325c5bed"
            alt="Agricultural freight transport and export logistics"
            className="w-full h-[400px] object-cover shadow-2xl"
          />
          <div className="mt-4 text-center">
            <p className="text-sm text-gray-500 uppercase tracking-wider">Agricultural commodity transport infrastructure</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-gray-50 p-10 shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="mb-8">
                  <Icon className="w-12 h-12 text-emerald-700" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-light text-gray-900 mb-4 tracking-tight">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed font-light text-lg">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LogisticsSection;
